import React, { FC } from 'react';
import { observer } from 'mobx-react';
import BankAchIcon from '../../../../../images/payment/bank-ach-icon.svg';
import CardIcon from '../../../../../images/payment/card-icon.svg';

type IProps = {
    type: string;
    hideText?: boolean;
};

const RenderPaymentMethodType: FC<IProps> = ({ type, hideText }) => {
    if (!type) return null;
    const cardIcon = (type: string) => {
        switch (type?.toLowerCase()) {
            case 'card':
                return CardIcon;
            case 'bank':
                return BankAchIcon;
            default:
                return '';
        }
    };
    return (
        <div>
            <img src={cardIcon(type)} style={{ paddingRight: '15px' }} />
            {hideText ? '' : type}
        </div>
    );
};

export default observer(RenderPaymentMethodType);
